import React, { useState, useEffect } from 'react';
import { IonText } from '@ionic/react';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday'
import 'dayjs/locale/zh-tw';

dayjs.extend(weekday)
dayjs.locale('zh-tw')

const TimeClock: React.FC = () => {
  const [date, setDate] = useState(new Date());
  function tick() {
    setDate(new Date());
  }

  useEffect(() => {
    var timerID = setInterval( () => tick(), 1000 );

    return function cleanup() {
        clearInterval(timerID);
      };
  });

  return (
    <div className="ion-padding-horizontal">
      <IonText className="ion-text-center">
        <h1>
          { dayjs().format('YYYY.MM.DD 星期dd') }<br />
          { date.toLocaleTimeString() }
        </h1>
      </IonText>
    </div>
  );
};

export default TimeClock;